module.exports = __webpack_public_path__ + "img/close.f263caca.png";